import { ReactNode, lazy, Suspense } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import BackButton from "./BackButton";

const AIChatWidget = lazy(() => import("./AIChatWidget"));

export default function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1 pt-[calc(3.5rem+1.5rem)] md:pt-[calc(4rem+1.5rem)]">
        <BackButton />
        {children}
      </main>
      <Footer />
      <WhatsAppButton />
      <Suspense fallback={null}>
        <AIChatWidget />
      </Suspense>
    </div>
  );
}
